var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 50,
    viewBox: "0 0 204 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.722 29.4948V6.79104H71.2316C75.5881 6.79104 78.073 9.85453 78.073 13.4293C78.073 17.004 75.5544 20.0675 71.2316 20.0675H64.662V29.4961H62.722V29.4948ZM71.0285 8.56159H64.6634V18.297H71.0285C74.0234 18.297 76.0321 16.2883 76.0321 13.4293C76.0321 10.5703 74.0234 8.56159 71.0285 8.56159Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0918 29.4947V13.0539H83.8623V15.8792C85.2575 14.0414 87.1303 12.7135 89.4108 12.7135V14.6536C89.104 14.5849 88.8659 14.5849 88.5255 14.5849C86.8572 14.5849 84.6104 16.0824 83.8623 17.5125V29.4947H82.0918Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.928 21.2582C91.928 16.4591 95.0252 12.6462 99.8256 12.6462C104.693 12.6462 107.757 16.4591 107.757 21.2582C107.757 26.0572 104.693 29.9037 99.8256 29.9037C95.0265 29.9037 91.928 26.0572 91.928 21.2582ZM105.85 21.2582C105.85 17.6161 103.706 14.2459 99.8256 14.2459C96.0127 14.2459 93.8345 17.6161 93.8345 21.2582C93.8345 24.9338 96.0127 28.3041 99.8256 28.3041C103.706 28.3041 105.85 24.9338 105.85 21.2582Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.319 21.7506C115.12 23.6288 117.92 25.2015 121.446 25.2015C124.437 25.2015 125.894 23.7835 125.894 22.3264C125.894 20.4092 123.67 19.758 120.718 19.0678C116.54 18.1099 111.171 16.9596 111.171 11.247C111.171 6.99146 114.852 3.54049 120.872 3.54049C124.936 3.54049 128.311 4.7675 130.84 7.10582L127.811 11.0936C125.741 9.1764 122.98 8.29516 120.488 8.29516C118.034 8.29516 116.731 9.36879 116.731 10.9026C116.731 12.6274 118.878 13.1642 121.83 13.8544C126.048 14.8123 131.414 16.0783 131.414 21.7519C131.414 26.4299 128.079 29.9562 121.177 29.9562C116.269 29.9562 112.743 28.3081 110.326 25.8917L113.319 21.7506Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.094 29.4947V3.92259H153.191V8.60057H140.539V14.1598H152.923V18.8378H140.539V24.7804H153.191V29.4961H135.094V29.4947Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.447 29.4947V3.92259H175.544V8.60057H162.891V14.1598H175.276V18.8378H162.891V24.7804H175.544V29.4961H157.447V29.4947Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.798 29.4947V3.92259H189.882C197.895 3.92259 203.454 9.02168 203.454 16.7282C203.454 24.4347 197.895 29.4961 189.882 29.4961H179.798V29.4947ZM185.243 24.7024H189.882C194.943 24.7024 197.895 21.0604 197.895 16.7282C197.895 12.2036 195.134 8.71493 189.882 8.71493H185.243V24.7024Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1928 36.0831V41.8657H66.4743L63.4754 37.6034V41.8657H62.6493V36.0831H63.3678L66.3667 40.3454V36.0831H67.1928Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1643 36.0831V39.6686C75.1643 41.1728 74.3719 41.9733 72.9673 41.9733C71.5546 41.9733 70.7702 41.1714 70.7702 39.6686V36.0831H71.5963V39.5193C71.5963 40.7584 72.1331 41.1876 72.9673 41.1876C73.7933 41.1876 74.3301 40.7584 74.3301 39.5193V36.0831H75.1643Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9465 41.8657L80.7491 39.6269C80.6831 39.635 80.6091 39.635 80.5257 39.635H79.5678V41.8657H78.7417V36.0831H80.5257C81.8469 36.0831 82.6071 36.8594 82.6071 37.859C82.6071 38.5614 82.2357 39.1479 81.5657 39.4372L82.9367 41.8657H81.9465ZM80.5257 38.8829C81.3276 38.8829 81.7568 38.4779 81.7568 37.859C81.7568 37.2388 81.3276 36.8352 80.5257 36.8352H79.5678V38.8842H80.5257V38.8829Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5211 36.8352H88.0586V41.8657H87.2326V36.8352H85.7701V36.0831H89.5211V36.8352Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2451 36.0831V39.6686C97.2451 41.1728 96.4527 41.9733 95.0481 41.9733C93.6354 41.9733 92.851 41.1714 92.851 39.6686V36.0831H93.6771V39.5193C93.6771 40.7584 94.2139 41.1876 95.0481 41.1876C95.8741 41.1876 96.411 40.7584 96.411 39.5193V36.0831H97.2451Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M104.027 41.8657L102.83 39.6269C102.764 39.635 102.69 39.635 102.607 39.635H101.649V41.8657H100.823V36.0831H102.607C103.928 36.0831 104.688 36.8594 104.688 37.859C104.688 38.5614 104.317 39.1479 103.647 39.4372L105.018 41.8657H104.027ZM102.607 38.8829C103.408 38.8829 103.838 38.4779 103.838 37.859C103.838 37.2388 103.408 36.8352 102.607 36.8352H101.649V38.8842H102.607V38.8829Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.008 36.0831V41.8657H108.182V36.0831H109.008Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.129 36.0831V41.8657H116.41L113.412 37.6034V41.8657H112.585V36.0831H113.304L116.303 40.3454V36.0831H117.129Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.092 38.743V41.8657H125.563L125.489 40.9239C125.092 41.5764 124.424 41.9733 123.44 41.9733C121.722 41.9733 120.499 40.6683 120.499 38.9744C120.499 37.2806 121.722 35.9836 123.44 35.9836C124.398 35.9836 125.208 36.3886 125.737 37.0491L125.043 37.5039C124.687 37.0572 124.142 36.7518 123.44 36.7518C122.085 36.7518 121.341 37.851 121.341 38.9744C121.341 40.0978 122.085 41.197 123.44 41.197C124.646 41.197 125.308 40.4449 125.439 39.4951H123.514V38.743H126.092Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M137.508 41.1136V41.8657H134.236V36.0831H137.424V36.8352H135.07V38.4954H137.243V39.2475H135.07V41.1149H137.508V41.1136Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.348 41.8657L142.927 39.6431L141.514 41.8657H140.507L142.39 38.9246L140.656 36.0831H141.656L142.928 38.2479L144.201 36.0831H145.209L143.475 38.9246L145.35 41.8657H144.348Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M152.444 40.4449L153.131 40.8997C152.602 41.5603 151.792 41.9733 150.834 41.9733C149.124 41.9733 147.893 40.6683 147.893 38.9744C147.893 37.2806 149.124 35.9836 150.834 35.9836C151.792 35.9836 152.602 36.3886 153.131 37.0572L152.444 37.5039C152.081 37.0572 151.536 36.7518 150.834 36.7518C149.487 36.7518 148.735 37.851 148.735 38.9744C148.735 40.0978 149.487 41.197 150.834 41.197C151.535 41.197 152.08 40.8916 152.444 40.4449Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.606 41.1136V41.8657H156.334V36.0831H159.523V36.8352H157.168V38.4954H159.341V39.2475H157.168V41.1149H159.606V41.1136Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M166.223 41.1136V41.8657H163.018V36.0831H163.844V41.1136H166.223Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M172.757 41.1136V41.8657H169.553V36.0831H170.379V41.1136H172.757Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.358 41.1136V41.8657H176.086V36.0831H179.275V36.8352H176.92V38.4954H179.093V39.2475H176.92V41.1149H179.358V41.1136Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M187.313 36.0831V41.8657H186.595L183.596 37.6034V41.8657H182.77V36.0831H183.488L186.487 40.3454V36.0831H187.313Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M195.235 40.4449L195.921 40.8997C195.393 41.5603 194.583 41.9733 193.625 41.9733C191.915 41.9733 190.684 40.6683 190.684 38.9744C190.684 37.2806 191.915 35.9836 193.625 35.9836C194.583 35.9836 195.393 36.3886 195.921 37.0572L195.235 37.5039C194.872 37.0572 194.327 36.7518 193.625 36.7518C192.278 36.7518 191.526 37.851 191.526 38.9744C191.526 40.0978 192.278 41.197 193.625 41.197C194.326 41.197 194.872 40.8916 195.235 40.4449Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M202.397 41.1136V41.8657H199.125V36.0831H202.313V36.8352H199.959V38.4954H202.132V39.2475H199.959V41.1149H202.397V41.1136Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9635 24.2907C49.9635 24.2907 49.58 28.1238 45.2142 30.746L30.2291 39.7494C29.5846 40.1369 29.1891 40.8338 29.1891 41.5873V47.838C29.1891 49.4727 30.9664 50.5423 32.375 49.7122C32.3858 49.7054 32.3952 49.7001 32.4059 49.6933L46.9928 40.9307C48.9665 39.7454 50.1599 37.5995 50.1249 35.2975L49.9635 24.2907Z",
    fill: "url(#paint0_linear_560_363)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5589 46.576C37.5589 46.576 40.6129 44.2269 40.5376 39.1359L40.1097 10.2608L46.6282 10.1639C48.3544 10.1383 49.7751 11.5174 49.8007 13.2435L50.1451 36.5325C50.168 38.0542 49.3782 39.4736 48.0745 40.2566L37.5589 46.576Z",
    fill: "url(#paint1_linear_560_363)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7913 12.5695C49.7684 11.0532 48.945 9.66342 47.6265 8.91537L32.3898 0.281902C30.961 -0.528032 29.1904 0.503895 29.1904 2.14664V8.30725C29.1904 9.07951 29.6061 9.79123 30.2775 10.172L45.003 18.5148C49.4334 21.0254 49.9729 24.8302 49.9729 24.8302L49.7913 12.5695Z",
    fill: "url(#paint2_linear_560_363)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.182112 24.2907C0.182112 24.2907 0.565553 28.1238 4.9314 30.746L19.9165 39.7494C20.561 40.1369 20.9565 40.8338 20.9565 41.5873V47.838C20.9565 49.4727 19.1792 50.5423 17.7706 49.7122C17.7598 49.7054 17.7504 49.7001 17.7397 49.6933L3.15142 40.9307C1.17771 39.7454 -0.0156622 37.5995 0.0193184 35.2975L0.182112 24.2907Z",
    fill: "url(#paint3_linear_560_363)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5868 46.576C12.5868 46.576 9.53269 44.2269 9.60803 39.1359L10.0359 10.2608L3.51738 10.1639C1.79122 10.1383 0.370471 11.5174 0.344908 13.2435L0.000483645 36.5325C-0.0223883 38.0542 0.767365 39.4736 2.07106 40.2566L12.5868 46.576Z",
    fill: "url(#paint4_linear_560_363)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.354319 12.5695C0.377191 11.0532 1.20058 9.66342 2.51908 8.91537L17.7558 0.281902C19.1846 -0.528032 20.9552 0.503895 20.9552 2.14664V8.30725C20.9552 9.07951 20.5394 9.79123 19.8681 10.172L5.14397 18.5148C0.713542 21.0254 0.174034 24.8302 0.174034 24.8302L0.354319 12.5695Z",
    fill: "url(#paint5_linear_560_363)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3023 20.5747C22.0813 20.5747 22.8603 20.5747 23.6406 20.5747C23.6541 20.1065 23.6796 19.7297 23.7308 19.4378C23.7308 19.4378 24.0792 14.4598 28.9482 15.7648C28.2352 15.5428 27.4777 15.4218 26.6933 15.4218H19.0689V17.6215C19.0689 19.8428 19.708 20.5747 21.3023 20.5747Z",
    fill: "url(#paint6_linear_560_363)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7308 19.4378C23.9756 18.009 24.7775 18.5942 27.2517 20.3984C27.9742 20.911 28.5554 21.3213 28.9926 21.6725C34.2639 25.4787 29.5187 30.1243 29.5187 30.1243C32.3239 28.9955 34.3178 26.2428 34.3178 23.0462C34.3178 19.6369 32.0508 16.7322 28.9496 15.7648C24.0792 14.4598 23.7308 19.4378 23.7308 19.4378Z",
    fill: "url(#paint7_linear_560_363)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2503 25.6643C24.3241 27.8587 23.7698 28.2865 23.6648 25.5163H21.4705C19.1658 25.5163 19.0689 26.9263 19.0689 28.3094C19.0689 30.68 19.0689 33.052 19.0689 35.4226C19.0783 34.8158 19.3165 30.6679 24.1492 30.6679H26.6933C27.6903 30.6679 28.6428 30.4742 29.5174 30.123C29.5174 30.123 34.2626 25.4773 28.9913 21.6712C30.7726 23.096 30.1995 23.5144 27.2503 25.6643Z",
    fill: "url(#paint8_linear_560_363)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1492 30.6693C19.3165 30.6693 19.0783 34.8158 19.0689 35.4239C19.0689 35.4481 19.0689 35.4737 19.0689 35.4979C19.0689 35.9311 19.0689 36.3657 19.0689 36.7989H21.7893C23.6339 36.7989 24.1492 35.5114 24.1492 33.5834C24.1492 32.612 24.1492 31.6406 24.1492 30.6693Z",
    fill: "url(#paint9_linear_560_363)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_560_363",
    x1: 47.434,
    y1: 33.4068,
    x2: 24.8279,
    y2: 51.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#5512AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3452,
    stopColor: "#681AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5794,
    stopColor: "#9A2FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8728,
    stopColor: "#E04CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_560_363",
    x1: 46.7268,
    y1: 10.7626,
    x2: 42.3227,
    y2: 45.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1971,
    stopColor: "#5512AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3205,
    stopColor: "#681AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5714,
    stopColor: "#9A2FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8859,
    stopColor: "#E04CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_560_363",
    x1: 26.8754,
    y1: -0.558707,
    x2: 56.8244,
    y2: 24.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0457,
    stopColor: "#5512AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1817,
    stopColor: "#681AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4581,
    stopColor: "#9A2FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8046,
    stopColor: "#E04CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_560_363",
    x1: 2.16731,
    y1: 32.9745,
    x2: 30.6039,
    y2: 53.0389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2498,
    stopColor: "#5512AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3327,
    stopColor: "#681AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5011,
    stopColor: "#9A2FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7122,
    stopColor: "#E04CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_560_363",
    x1: 3.41853,
    y1: 10.7626,
    x2: 7.82263,
    y2: 45.9954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1287,
    stopColor: "#5512AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#681AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5369,
    stopColor: "#9A2FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8798,
    stopColor: "#E04CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_560_363",
    x1: 25.2623,
    y1: 0.0203284,
    x2: -4.80776,
    y2: 21.1939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0418,
    stopColor: "#5512AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1979,
    stopColor: "#681AAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5151,
    stopColor: "#9A2FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9126,
    stopColor: "#E04CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_560_363",
    x1: 17.5737,
    y1: 17.9986,
    x2: 27.4526,
    y2: 17.9986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1258,
    stopColor: "#003BC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8081,
    stopColor: "#00BBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_560_363",
    x1: 23.7302,
    y1: 22.8355,
    x2: 34.3169,
    y2: 22.8355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#003BC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8081,
    stopColor: "#00BBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_560_363",
    x1: 31.266,
    y1: 23.3647,
    x2: 16.7224,
    y2: 33.6501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#003BC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8081,
    stopColor: "#00BBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_560_363",
    x1: 20.8445,
    y1: 29.2545,
    x2: 22.3771,
    y2: 38.2315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3791,
    stopColor: "#003BC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8081,
    stopColor: "#00BBCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.920017f125995ddbb514b33cad6a6e2f.svg";
export { ForwardRef as ReactComponent };